module.exports = __webpack_public_path__ + "img/1491872965.d0eacd57.jpg";